import { Navigate, Outlet, useLocation } from 'react-router'
import { useSessao } from '../../hooks/useSessao'

/**
 * `replace` evita que o voltar do Android caia de novo na rota protegida,
 * criando um laço entre login e a área da empresa.
 */
export function RotaProtegida() {
  const { autenticado } = useSessao()
  const local = useLocation()

  if (!autenticado) {
    return <Navigate to="/entrar" replace state={{ de: local.pathname }} />
  }
  return <Outlet />
}
